import type { FC, ReactNode } from 'react';
import styles from './ModalContent.module.css';

interface ModalContentProps {
  children: ReactNode;
}

export const ModalContent: FC<ModalContentProps> = ({ children }) => (
  <div className={styles.content}>{children}</div>
);
